import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../assets/jss/DialogTC";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CustomDialogAction from "../../CustomComponents/CustomDialogAction/CustomDialogAction";
import CloseIcon from "../../../assets/images/close.svg";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import errorToast from "../../../assets/images/errorToast.png";

const styles = (theme) => ({});

const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);

const DialogActions = withStyles((theme) => ({}))(CustomDialogAction);

export default function ReplaceActionDialog(props:any) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [open, setOpen] = React.useState(props.dialogOpen);
    const handleClose = (confirmDelete) => {
        setOpen(false);
        props.dialogClose(confirmDelete);
    };


    React.useEffect(() => {
        setOpen(props.dialogOpen);
    }, [props.dialogOpen]);

    return (
        <CustomDialog
            onClose={() => handleClose(false)}
            aria-labelledby="customized-dialog-title"
            open={open}
            className={classes.dialogWrapper}
        >
            <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={() => handleClose(false)}
            >
                <img src={CloseIcon} />
            </IconButton>
            <DialogContent className={classes.replaceDialogContentWrapper}>
                <div className={classes.dialogContentIcons}>
                    <div className={classes.dialogContentImg}>
                        <img src={errorToast} />
                    </div>
                </div>
                <Typography className={classes.dialogOOPs}>
                    {t("OPPS")}
                </Typography>
                <Typography className={classes.dialogText}>
                    {props.dialogMessage}
                </Typography>
            </DialogContent>
            <DialogActions className={clsx(classes.dialogActionWrapper, classes.closeReplace)}>
                <CustomButton
                    className={classes.closeView}
                    autoFocus
                    onClick={() => handleClose(false)}
                    variant="contained"
                    color="primary"
                    defaultrounded="true"
                >
                    {t("CLOSE")}
                </CustomButton>
            </DialogActions>
        </CustomDialog>
    );
}
